export default __webpack_public_path__ + "static/media/brainferg4.77167011.jpg";